<app-customers-hero></app-customers-hero>
<app-common-companies-panel
  [companiesData]="companiesData"
></app-common-companies-panel>
<app-customers-customers></app-customers-customers>
<app-customers-stories></app-customers-stories>
<app-customer-rating-and-features></app-customer-rating-and-features>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
